import React,{useState,useEffect,useRef} from "react";
import {addcandidate,updateCandidate} from './api/Calls';
import {getNewCondidateList,getCompandy} from '../../../Redux/Actions/newJoinerAction';
import { useDispatch,useSelector } from "react-redux";
import moment from "moment";

const AddCondidateModel = ({condidateDetail,setSelelected}) => {
    const dispatch = useDispatch();
    const {company} = useSelector((state) => state.NewJoinerReducer);
    const cancelRef = useRef(null);
    const initialValues = {
      comp_id: "",
      first_name: "",
      personal_email: "",
      contact_no:"",
      joining_date:""
    };
    const [values, setValues] = useState(initialValues);

    useEffect(() =>{
        if (condidateDetail) setValues(condidateDetail);
        dispatch(getCompandy());
    },[condidateDetail,dispatch])
    //console.log(values)
    const handleChange =  (e) => {
        const { name, value } = e.target;
        console.log(value)
        setValues({ ...values, [name]: value });
        
      };
    
    const handleCancel = () => {
        setSelelected(null);
        setValues(initialValues);
      };
    
    const handleSubmit = () =>{
        if (comp_id === "" || first_name === "" || personal_email ==="" || contact_no ==="" || joining_date ===""){
            return alert("All fields are required");
        }
        addcandidate({comp_id:comp_id,first_name:first_name,personal_email:personal_email,contact_no:contact_no,joining_date:joining_date}).then((res) =>{
            if (res.status) {
                setValues(initialValues)
                cancelRef.current.click();
                dispatch(getNewCondidateList())
                return alert(res.msg)
                
            }else{
                return alert(res.msg)
            }
        })
    }
    const handelUpdate = () =>{
        if (comp_id === "" || first_name === "" || personal_email ==="" || contact_no ==="" || joining_date ===""){
            return alert("All fields are required");
        }
        const updatedData = {
            comp_id:comp_id,
            first_name:first_name,
            personal_email:personal_email,
            contact_no:contact_no,
            joining_date:joining_date
        }
        updateCandidate(condidateDetail.condidateID,updatedData).then((res) =>{
            if (res.status) {
                setValues(initialValues)
                cancelRef.current.click();
                dispatch(getNewCondidateList())
                return alert(res.msg)
            }else{
                return alert(res.msg)
            }
        })
    }
    const { comp_id, first_name,personal_email,contact_no,joining_date } = values;
    console.log(first_name)
    return (
        <>
            <div className="modal fade" id="addcandidate" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body">
                            <button type="button" className="float-end btn_close" data-bs-dismiss="modal" aria-label="Close" ref={cancelRef} onClick={handleCancel}>
                                <i className="icon icon-cross" />
                            </button>
                            <div className="dash_white_box_ttl text-center" id="exampleModalLabel">{condidateDetail ? 'Update':'Add'} Candidate</div>
                           
                            <div className="mb-2">
                                    <label className="col-form-label">Company Name</label>
                                    <select className="form-select"  onChange={handleChange} name="comp_id" value={comp_id}>
                                    <option value="">--Select Company Name--</option>
                                    {company?.map((item,key)=>{
                                        return(
                                            <option  key={key} value={item.id}>{item.name}</option>
                                        )
                                    })}
                                    </select>
                                </div>
                                <div className="mb-2">
                                    <label className="col-form-label">Candidate Name</label>
                                    <input type="text" className="form-control"  onChange={handleChange} name="first_name" value={first_name}/>
                                </div>
                                <div className="mb-2">
                                    <label className="col-form-label">Personal Email</label>
                                    <input type="text" className="form-control"  onChange={handleChange} name="personal_email"  value={personal_email}/>
                                </div>
                                <div className="mb-2">
                                    <label className="col-form-label">Contact Number</label>
                                    <input type="text" className="form-control" maxLength={10} onChange={handleChange} name="contact_no" value={contact_no}/>
                                </div>
                                <div className="mb-3">
                                    <label className="col-form-label">Date of Joining</label>
                                    <input type="date" className="form-control"  onChange={handleChange} name="joining_date" value={moment(joining_date).format('yyyy-MM-DD')} />
                                </div>
                            <div className="modalfooter">
                                <button type="button" className="btn_6 float-end ml10" data-bs-dismiss="modal" ref={cancelRef} onClick={handleCancel}>Cancel</button>
                                <button type="button" className="btn_5 float-end " onClick={condidateDetail ? handelUpdate : handleSubmit }>{condidateDetail ? 'Update':'Add'}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default AddCondidateModel;